import { createClient, summarizeDay } from "@app/ai";
import { Button, Card } from "@app/ui";
import { useState } from "react";
import { useSettingsStore, useTasksStore } from "../../stores/index.js";
import { useI18n } from "../../lib/useI18n.js";

export function DailyDigest() {
  const { t } = useI18n();
  const anthropicApiKey = useSettingsStore((s) => s.anthropicApiKey);
  const tasks = useTasksStore((s) => s.tasks);
  const [summary, setSummary] = useState<string>("");
  const [busy, setBusy] = useState(false);

  async function go() {
    if (!anthropicApiKey) { setSummary(t("aiQuickAdd.missingKey")); return; }
    setBusy(true);
    try {
      setSummary(await summarizeDay(createClient(anthropicApiKey), tasks));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card className="p-4">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-sm font-medium">{t("ai.dailyDigest")}</h2>
        <Button size="sm" variant="outline" onClick={() => void go()} disabled={busy}>
          {busy ? t("ai.dailyDigest.generating") : summary ? t("ai.dailyDigest.refresh") : t("ai.dailyDigest.generate")}
        </Button>
      </div>
      <p className="text-sm leading-6 text-muted-foreground">{summary || t("ai.dailyDigest.empty")}</p>
    </Card>
  );
}
